import React, { useEffect, useState, useRef } from 'react'
import { Menu } from 'src/components/calendar/Menu'
import { EventReport } from 'src/components/calendar/EventReport'
import { DesktopWidget } from 'src/components/calendar/DesktopWidget'

/* eslint-disable css-modules/no-unused-class */
import style from './eventNavigation.css'

export const EventNavigation = ({
  slug,
  eventData,
  loading,
  listingStatus,
  ticketButtonText,
  isEventReported,
  setIsEventReported,
  isEventSet,
  isDesktop,
  viewer,
  isTimedEntry,
}) => {
  const [expanded, setExpanded] = useState(false)
  const [navHeight, setNavHeight] = useState(0)
  const navRef = useRef()

  const BANNER_SIZE = 544.8

  const handleScroll = () => {
    const offset = window.pageYOffset
    if (offset >= BANNER_SIZE) {
      setExpanded(true)
    } else if ((offset < BANNER_SIZE)) {
      setExpanded(false)
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    setNavHeight(navRef.current.offsetHeight)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div className={style.navPlaceholder}>
      <div ref={navRef} className={`${style.nav} ${(expanded && !isEventSet) ? style.sticky : ''}`}>
        <div className={style.navContainer}>
          <Menu
            eventData={eventData}
            loading={loading}
            isSticky={expanded}
            navHeight={navHeight}
          />

          {isDesktop &&
            <div className={style.sidebar}>
              <DesktopWidget
                slug={slug}
                eventData={eventData}
                loading={loading}
                listingStatus={listingStatus}
                ticketButtonText={ticketButtonText}
                isEventSet={isEventSet}
                expanded={expanded}
                viewer={viewer}
                isTimedEntry={isTimedEntry}
              />
              <EventReport
                slug={slug}
                isEventSet={isEventSet}
                isEventReported={isEventReported}
                setIsEventReported={setIsEventReported}
                loading={loading}
                available={isEventSet || listingStatus === 'availableStandard'}
              />
            </div>
          }
        </div>
      </div>
    </div>
  )
}
